"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var boolean_serialiser_1 = require("./../serialisers/boolean-serialiser");
var string_serialiser_1 = require("./../serialisers/string-serialiser");
var error_report_list_serialiser_1 = require("./../services/error-report-list-serialiser");
var service_definition_1 = require("./../services/service-definition");
var security_command_script_serialiser_1 = require("./../services/authentication/security-command-script-serialiser");
var system_authentication_configuration_serialiser_1 = require("./../services/authentication/system-authentication-configuration-serialiser");
var change_principal_request_serialiser_1 = require("./../services/change-principal/change-principal-request-serialiser");
var authenticator_registration_parameters_serialiser_1 = require("./../services/security/authenticator-registration-parameters-serialiser");
var authenticator_registration_request_serialiser_1 = require("./../services/security/authenticator-registration-request-serialiser");
var authenticator_request_serialiser_1 = require("./../services/security/authenticator-request-serialiser");
var authenticator_response_serialiser_1 = require("./../services/security/authenticator-response-serialiser");
var list_global_permissions_result_serialiser_1 = require("./../services/security/list-global-permissions-result-serialiser");
var list_path_permissions_result_serialiser_1 = require("./../services/security/list-path-permissions-result-serialiser");
var security_configuration_serialiser_1 = require("./../services/security/security-configuration-serialiser");
exports.CHANGE_PRINCIPAL = {
    id: 5,
    request: change_principal_request_serialiser_1.ChangePrincipalRequestSerialiser,
    response: boolean_serialiser_1.BooleanSerialiser
};
exports.GET_SYSTEM_AUTHENTICATION = {
    id: 57,
    request: service_definition_1.NullSerialiser,
    response: system_authentication_configuration_serialiser_1.SystemAuthenticationConfigurationSerialiser
};
exports.UPDATE_SYSTEM_AUTHENTICATION = {
    id: 58,
    request: security_command_script_serialiser_1.SecurityCommandScriptSerialiser,
    response: error_report_list_serialiser_1.ErrorReportListSerialiser
};
exports.GET_SECURITY_CONFIGURATION = {
    id: 59,
    request: service_definition_1.NullSerialiser,
    response: security_configuration_serialiser_1.SecurityConfigurationSerialiser
};
exports.UPDATE_SECURITY_CONFIGURATION = {
    id: 60,
    request: security_command_script_serialiser_1.SecurityCommandScriptSerialiser,
    response: error_report_list_serialiser_1.ErrorReportListSerialiser
};
exports.AUTHENTICATOR_REGISTRATION = {
    id: 119,
    request: authenticator_registration_request_serialiser_1.AuthenticatorRegistrationRequestSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.AUTHENTICATOR = {
    id: 120,
    request: authenticator_request_serialiser_1.AuthenticatorRequestSerialiser,
    response: authenticator_response_serialiser_1.AuthenticatorResponseSerialiser
};
exports.AUTHENTICATOR_DEREGISTRATION = {
    id: 121,
    request: authenticator_registration_parameters_serialiser_1.AuthenticatorRegistrationParametersSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.LIST_GLOBAL_PERMISSIONS = {
    id: 143,
    request: service_definition_1.NullSerialiser,
    response: list_global_permissions_result_serialiser_1.ListGlobalPermissionsResultSerialiser
};
exports.LIST_PATH_PERMISSIONS = {
    id: 144,
    request: string_serialiser_1.StringSerialiser,
    response: list_path_permissions_result_serialiser_1.ListPathPermissionsResultSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/security-services.js
// module id = 1996
// module chunks = 1